import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7604ea12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-basket-page" }
const _hoisted_2 = {
  key: 1,
  class: "m-auto"
}
const _hoisted_3 = { class: "basket-total" }
const _hoisted_4 = {
  key: 2,
  class: "basket-footer-actions"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-save pr-8" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-12 pr-8" }, null, -1))
const _hoisted_7 = {
  key: 3,
  class: "basket-footer-actions2"
}
const _hoisted_8 = {
  key: 0,
  form: "customerDetails",
  type: "submit",
  class: "checkout"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-pay fs-16 pr-8" }, null, -1))
const _hoisted_10 = {
  key: 2,
  form: "customerDetails",
  type: "submit",
  class: "checkout"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-pay fs-16 pr-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_BasketItems = _resolveComponent("BasketItems")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: _ctx.$t('cashier.label.product-card')
    }, null, 8, ["text"]),
    (_ctx.products.length > 0)
      ? (_openBlock(), _createBlock(_component_BasketItems, {
          key: 0,
          products: _ctx.products,
          notAvailableProducts: _ctx.notAvailableProducts
        }, null, 8, ["products", "notAvailableProducts"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("cashier.title.select-product")), 1)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cashier.label.total")) + " " + _toDisplayString(_ctx.numberWithCommas(_ctx.total)) + " " + _toDisplayString(_ctx.currencySign), 1),
    (_ctx.isSave == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveOrderAction && _ctx.saveOrderAction(...args)))
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.save")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkOut && _ctx.checkOut(...args)))
          }, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.check-out")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.isSave)
            ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.ok")), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSave && _ctx.isVoucher)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkOut && _ctx.checkOut(...args))),
                type: "button",
                class: "checkout"
              }, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.check-out")), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSave && !_ctx.isVoucher)
            ? (_openBlock(), _createElementBlock("button", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.check-out")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}